import { h } from "preact";

export default function CapacityIcon({ node, className = "" }) {
  if (!node) return null;

  const url = node.capacityIcon?.reference.image.url;

  if (!url) return null;

  return (
    <img className={className} src={window.getSizedImageUrl(url, "100x")} />
  );
}
